import {inject, Injectable} from '@angular/core';
import {BaseService} from "../BaseService";
import {AppService} from "../app.service";

@Injectable({
  providedIn: 'root'
})
export class AlarmService extends BaseService {

  public selectedDeviceId!: number | null;
  private appService: AppService = inject(AppService);

  constructor() {
    super();
    this.cleanupServiceFields();
  }

  cleanupServiceFields(): void {
    this.selectedDeviceId = null;
  }


}
